import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, User, MessageCircle, ClipboardList } from 'lucide-react';
import { getWhatsAppLink } from '../../config/constants';

export function RegistrationChoice() {
  const navigate = useNavigate();
  const [showCandidateOptions, setShowCandidateOptions] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Créer un compte
          </h1>
          <p className="text-lg text-gray-600">
            Choisissez le type de compte que vous souhaitez créer
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Recruteur Option */}
          <button
            onClick={() => navigate('/register/recruiter')}
            className="group relative bg-white p-8 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:border-teal-500 transition-all duration-300"
          >
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <Building2 className="h-8 w-8 text-teal-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">Recruteur</h2>
              <p className="text-gray-600 text-center">
                Créez votre espace recruteur pour publier des offres d'emploi et gérer vos recrutements
              </p>
            </div>
          </button>

          {/* Candidat Option */}
          {!showCandidateOptions ? (
            <button
              onClick={() => setShowCandidateOptions(true)}
              className="group relative bg-white p-8 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:border-teal-500 transition-all duration-300"
            >
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <User className="h-8 w-8 text-teal-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">Candidat</h2>
                <p className="text-gray-600 text-center">
                  Créez votre profil candidat et trouvez l'emploi qui vous correspond
                </p>
              </div>
            </button>
          ) : (
            <div className="space-y-4">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                Choisissez votre méthode d'inscription
              </h3>
              
              {/* WhatsApp Option */}
              <a
                href={getWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-teal-500 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                  <MessageCircle className="h-6 w-6 text-green-600" />
                </div>
                <div className="flex-1">
                  <h4 className="text-base font-semibold text-gray-900">WhatsApp</h4>
                  <p className="text-sm text-gray-600">
                    Inscription rapide via WhatsApp
                  </p>
                </div>
              </a>

              {/* Classic Registration Option */}
              <button
                onClick={() => navigate('/register/worker')}
                className="group flex items-center w-full p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-teal-500 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                  <ClipboardList className="h-6 w-6 text-teal-600" />
                </div>
                <div className="flex-1 text-left">
                  <h4 className="text-base font-semibold text-gray-900">Formulaire classique</h4>
                  <p className="text-sm text-gray-600">
                    Inscription détaillée via formulaire
                  </p>
                </div>
              </button>

              {/* Back Button */}
              <button
                onClick={() => setShowCandidateOptions(false)}
                className="text-sm text-gray-600 hover:text-gray-900"
              >
                ← Retour
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}